export default __webpack_public_path__ + "static/media/Background_Login.385e6e25.svg";